export default __webpack_public_path__ + "static/color-picker-chart-light-689b4a875619d6200359c3337bb6f7a2.png";